import React, { useState } from 'react'
import { connect } from 'react-redux'
import { NavLink } from 'react-router-dom'
import { routes } from '../../constants/routes'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const mapStateToProps = (state) => {
    return {
        user: state.user,
        showSidebar: state.ui.showSidebar
    }
}

const AppNav = ({ dispatch, user, showSidebar }) => {
    const [ isOpen, setIsOpen ] = useState(false)
    const renderMenuOverlay = () => {
        return (
            <div className={`menu-overlay ${isOpen ? 'active' : ''}`}>
                <div className="closer" onClick={() => setIsOpen(false)}>
                    <FontAwesomeIcon icon="times" />
                </div>
                <div className="menu">
                    <div className="links">
                        <NavLink className={({ isActive }) => isActive ? 'active' : ''} onClick={() => setIsOpen(false)} to={routes.appIndex.path} end>Installations</NavLink>
                        <NavLink className={({ isActive }) => isActive ? 'active' : ''} onClick={() => setIsOpen(false)} to={routes.appUserIndex.path}>My Profile</NavLink>
                        <NavLink className={({ isActive }) => isActive ? 'active' : ''} onClick={() => setIsOpen(false)} to={routes.appTeamIndex.path}>My Team</NavLink>
                        { user?._computed?.roleLevel >= 1000 && <NavLink onClick={() => setIsOpen(false)} to={routes.adminInstallationIndex.path}>Admin</NavLink> }
                        <NavLink className={({ isActive }) => isActive ? 'active' : ''} onClick={() => setIsOpen(false)} to={routes.authLogout.path}>Logout</NavLink>
                    </div>
                    <div className="logo-wrapper">
                        <NavLink className={({ isActive }) => isActive ? 'active' : ''} onClick={() => setIsOpen(false)} to={routes.appIndex.path} end><img src="/imgs/optimus-gear-only-white.svg" alt="Optimus Technologies" height="50" /></NavLink>
                    </div>
                </div>
            </div>
        )
    }

    // const showTruckSidebar = () => {
    //     dispatch(saveUiState({ key: 'showSidebar', value: true }))
    // }

    // const renderTruckTitle = () => {
    //     if (showSidebar) {
    //         // TODO: Should this just be a back button or vary based on where we are?
    //         return (
    //             <Link onClick={() => setIsOpen(false)} to={routes.appIndex.path}>
    //                 <FontAwesomeIcon icon="arrow-left" />
    //                 Dashboard
    //             </Link>
    //         )
    //     }
    //     return (
    //         <span onClick={showTruckSidebar}>
    //             <FontAwesomeIcon icon="arrow-left" />
    //             Step List
    //         </span>
    //     )
    // }

    return (
        <>
            <div className={`nav ${isOpen ? 'open' : ''}`}>
                <div className="container nav-wrapper">
                    {/* <div className="nav-title">
                        <Routes>
                            <Route path={nestedRoutePath(routes.appIndex.path, routes.appInstallationView.path, true)} element={renderTruckTitle()} />
                        </Routes>
                    </div> */}
                    <div className="menu-wrapper">
                        <span className="hamburger" onClick={() => setIsOpen(!isOpen)}>
                            <FontAwesomeIcon icon="bars" />
                        </span>
                    </div>
                </div>
            </div>
            {renderMenuOverlay()}
        </>
    )
}

export default connect(mapStateToProps)(AppNav)
